import { render, staticRenderFns } from "./SurveyUlasanPage.vue?vue&type=template&id=61bcdc34&"
import script from "./SurveyUlasanPage.vue?vue&type=script&lang=js&"
export * from "./SurveyUlasanPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports